import React from "react";
import "../styles/pages.css";

function ContactUs() {
  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="contact-hero-content">
          <h1 className="contact-title fade-in">Contact Us</h1>
          <p className="contact-subtitle slide-up">
            Grow your business with PICKTECH solutions
          </p>
        </div>
      </div>

      <div className="contact-main-section">
        <div className="container">
          <h2 className="section-title">Contact Information</h2>
          <div className="title-underline"></div>

          <div className="contact-layout">
            {/* 왼쪽 연락처 정보 섹션 */}
            <div className="contact-info-section">
              <div className="contact-info-cards">
                <div className="contact-info-card fade-in">
                  <div className="contact-info-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="contact-info-content">
                    <h3>Address</h3>
                    <p>22 Church Street, Lidcombe NSW 2141</p>
                  </div>
                </div>

                <div
                  className="contact-info-card fade-in"
                  style={{ animationDelay: "0.2s" }}
                >
                  <div className="contact-info-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="contact-info-content">
                    <h3>Email</h3>
                    <p>
                      <a href="mailto:jacob.yu.webdev@gmail.com">
                        jacob.yu.webdev@gmail.com
                      </a>
                    </p>
                  </div>
                </div>

                <div
                  className="contact-info-card fade-in"
                  style={{ animationDelay: "0.4s" }}
                >
                  <div className="contact-info-icon">
                    <i className="fas fa-phone"></i>
                  </div>
                  <div className="contact-info-content">
                    <h3>Phone</h3>
                    <p>
                      <a href="tel:+61414989606">+61 414 989 606</a>
                    </p>
                  </div>
                </div>

                <div
                  className="whatsapp-btn-container fade-in"
                  style={{ animationDelay: "0.6s" }}
                >
                  <a
                    href="https://chat.whatsapp.com/KP8nHB9nnqWJ71LyW8DgiX"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-whatsapp btn-lg"
                  >
                    <i className="fab fa-whatsapp"></i> Contact via WhatsApp
                  </a>
                </div>
              </div>
            </div>

            {/* 오른쪽 지도 섹션 */}
            <div
              className="map-section fade-in"
              style={{ animationDelay: "0.8s" }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3314.2734955673404!2d151.04225287649068!3d-33.835101073236174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12bbe85c678a61%3A0x6b73f626bd3e2db2!2s22%20Church%20St%2C%20Lidcombe%20NSW%202141!5e0!3m2!1sen!2sau!4v1713754863901!5m2!1sen!2sau"
                width="100%"
                height="100%"
                style={{
                  border: 0,
                  borderRadius: "16px",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="PICKTECH office location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
